import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import formatValues, { formatReceived } from 'utils/formatValues';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';

export const baseURI = 'recaudacion/estados-de-ejecucion-pae/';

/**
 * ESTE ES EL HISTORIAL DE EJECUCIONES
 *  Estados de Ejecucion Objeto
  * @typedef {object} EstadosDeEjecucion
    "id": 2,
    "estatus_de_ejecucion": 2,
    "estatus_previo_de_ejecucion": 2,
    "actuacion": 1,
    "actuacion_previa": 1,
    "ejecucion": 20,
    "estado_previo_de_ejecucion": null,
    "tiene_cobros_a_cartera": false,
    "tiene_cobros_relacionados_a_ejecutor": false,
    "fecha_de_actuacion": null,
    "ejecutor": null,
    "fecha_de_asigno_ejecutor": null,
    "fecha_de_imprimio_reportes": null,
    "fecha_de_vencimiento_del_estado": null,
    "es_recibo_cancelado": false,
    "nota_de_errores_del_estado": null,
    "recibo": null,
    "usuario_cancelo_estado": null,
    "usuario_asigno_ejecutor": null,
    "usuario_imprimio_reportes": null,
    "motivo_de_cancelacion": null,
    "fecha_de_cancelacion": null,
    "observacion_de_cancelacion": null,
    "observaciones": null,
    "monto_pagado": 0,
    "zona_de_deligencia": null,
    "clave_de_credito": null,
    "estados_globales": 1
  }
 */

/**
 * GET Estados de Ejecucion
 * param {object} params
 * @returns {Promise<object>}
 */
export const getEstadosDeEjecucion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Estado de Ejecucion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEstadoDeEjecucion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Estado de Ejecucion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEstadoDeEjecucion = async (values) => {
  try {
    const formatedValues = formatValues(values, {
      clean: false,
    });

    formatedValues.fecha_de_actuacion = `${formatedValues.fecha_de_actuacion} 00:00:00`;
    if (formatedValues?.fecha_de_asigno_ejecutor) {
      formatedValues.fecha_de_asigno_ejecutor = `${formatedValues.fecha_de_asigno_ejecutor} 00:00:00`;
    }

    const response = await API.post(baseURI, formatedValues);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Estado de Ejecucion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEstadoDeEjecucion = async (id, values) => {
  try {
    const formatedValues = formatValues(values, {
      clean: false,
    });

    const response = await API.patch(`${baseURI}${id}`, formatedValues);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Estado de Ejecucion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEstadoDeEjecucion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
